module.exports = __webpack_public_path__ + "static/media/instagram.ac567543.png";